import React from "react";
import { Search } from "playground/cms/List/Filter";
import { useHasScope } from "playground/console/UserAccess";
import { SCOPE_CONSOLE } from "config/access-scopes";
import { usePushRoute } from "state/hooks";

//import PropTypes from 'prop-types';

export function ProjectsFilter(props) {
    const {} = props;

    const consoleAccess = useHasScope(SCOPE_CONSOLE);
    const pushRoute = usePushRoute();
    const openConsole = () => pushRoute("/console");

    return (
        <div>
            <Search type={"console.services"} name={"search"} />
            {consoleAccess && <div onClick={openConsole}>Administration</div>}
        </div>
    );
}

ProjectsFilter.propTypes = {};

ProjectsFilter.defaultProps = {};

export default ProjectsFilter;
